import MyDnaDetail from "./MyDnaDetail";
export default MyDnaDetail;
